/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...



document.querySelectorAll('.dp-size-list-item').forEach(item => {
    item.addEventListener('click', function () {
        // Toggle the selected class
        document.querySelectorAll('.dp-size-list-item').forEach(el => el.classList.remove('selected'));
        this.classList.add('selected');

        const isInches = this.classList.contains('inches');

        // Find all size-right-sections and toggle visibility for each
        document.querySelectorAll('.size-right-section').forEach(section => {
            section.querySelector('.inches-detail').style.display = isInches ? 'block' : 'none';
            section.querySelector('.centimeters-detail').style.display = isInches ? 'none' : 'block';
        });
    });
});
